import { IPromotedListingTypes } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import {
  IApiResponse,
} from '@/shared';
import { IAction } from '@/shared/interfaces/store-base';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { IClientPromotedListingTypesMeta, IPromotedListingTypesStore } from '@/shared/interfaces/promoted-listing-types-store';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/syndication-api/promoted_listing_types';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {};
const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IPromotedListingTypes>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'promoted-listing-types/'

  state: {
    ...base.state,

    clientPromotedListingTypes: undefined,
    clientDefaultPromotedListingContracts: undefined,
    contractSubscriptions: undefined,
  },

  getters: {
    ...base.getters,
    clientPromotedListingTypes: (state: IPromotedListingTypesStore) => state.clientPromotedListingTypes?.data || [],
    clientPromotedListingTypeIds: (state: IPromotedListingTypesStore) => (state.clientPromotedListingTypes?.data
      ? state.clientPromotedListingTypes?.data.map((cplt) => cplt.id!)
      : []),
    clientDefaultPromotedListingContracts: (state: IPromotedListingTypesStore) => state.clientDefaultPromotedListingContracts || [],
    contractSubscriptions: (state: IPromotedListingTypesStore) => state.contractSubscriptions || [],
  },

  mutations: {
    ...base.mutations,

    setClientPromotedListingTypes: (
      state: IPromotedListingTypesStore,
      payload: IApiResponse<IPromotedListingTypes[], IClientPromotedListingTypesMeta>,
    ) => {
      state.clientPromotedListingTypes = Array.isArray(payload)
        ? { ...state.clientPromotedListingTypes && state.clientPromotedListingTypes, ...{ data: payload } }
        : payload;
    },
    setDefaultClientPromotedListingContracts: (
      state: IPromotedListingTypesStore,
      payload: IApiResponse<IPromotedListingTypes[], IClientPromotedListingTypesMeta>,
    ) => {
      state.clientDefaultPromotedListingContracts = [...payload.meta?.defaultPromotedListingContracts ?? []];
    },
    setContractSubscriptions: (
      state: IPromotedListingTypesStore,
      payload: IApiResponse<IPromotedListingTypes[], IClientPromotedListingTypesMeta>,
    ) => {
      state.contractSubscriptions = [...payload.meta?.contractSubscriptions ?? []];
    },
  },

  actions: {
    ...base.actions,

    getClientPromotedListingTypes: async (ctx: IAction<IPromotedListingTypesStore>, clientId: number) => {
      const result = await adminRequest.get(`/syndication-api/client_promoted_listing_types/${clientId}`);
      ctx.commit('setClientPromotedListingTypes', result);
      ctx.commit('setDefaultClientPromotedListingContracts', result);
      ctx.commit('setContractSubscriptions', result);
    },
  },
};
